import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cdfl-circuit',
  templateUrl: './circuit.component.html',
  styleUrls: ['./circuit.component.scss']
})
export class CircuitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
